module.exports = __webpack_public_path__ + "img/face_with_thermometer.f261a5f8.gif";